const item =[
    {
        id: 1,
        url : 'https://photoshopcafe.com/tips.htm',
        img: "image/design/cafe.jpg"
    },

    {
        id: 2,
        url : 'https://helpx.adobe.com/photoshop/tutorials.html',
        img: "image/design/adobe.png"
    }
]

export default item;